import { Component, Input } from '@angular/core';
import { Wizard } from './wizard.component';
import { isString } from 'lodash';

@Component({
    selector: 'wizard-tab',
    template: require('./wizard.tab.template.html')
})
export class WizardTab {

    @Input('id')
    public tabId: string;

    public isDefault: boolean;

    public isDone: boolean = false;

    @Input('default')
    set defaultProp(attr: string) {
        this.isDefault = isString(attr);
    }

    isSelected: boolean = false;
    private wizardComponent: Wizard;
    //todo andrey add types
    public prev;
    public next;

    setPrevTab(prevTab) {
        this.prev = prevTab;
    }

    setNextTab(nextTab) {
        this.next = nextTab;
    }

    selectTab() {
        this.wizardComponent.handleTabSelected(this);
    }

    setTabState(isSelected: boolean) {
        this.isSelected = isSelected;
    }

    setupParent(parent: Wizard) {
        this.wizardComponent = parent;
    }

}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/angular-router-loader/src!./src/common/components/wizard/wizard.tab.ts